import { IConfig } from "../types/IConfig";
import { ConfigContext } from "../contexts/config.context";
import { useContext } from "react";

export const useConfig = <TConfig>(): IConfig<TConfig> => {
  return useContext<IConfig<TConfig>>(ConfigContext);
}